import React, { useState } from 'react';
import BillingStatus from './BillingStatus.component';
import ModalModule from '../modal';

const { Modal, ModalButtonActionType } = ModalModule;

const BillingStatusModal = ({ modalId }) => {
	const [modalTitle, setModalTitle] = useState('Billing Status');

	const modalTitleCallback = title => {
		setModalTitle(title);
	};

	return (
		<Modal
			modalId={modalId}
			className="billing-status-modal"
			header={modalTitle}
			primaryButton={{
				type: ModalButtonActionType.Cancel,
				text: 'Close',
			}}
			size="small"
		>
			<BillingStatus
				modalTitleCallback={modalTitleCallback}
			/>
		</Modal>
	);
};

export default BillingStatusModal;
